import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, Text } from '@dixa/lib-shared-habla';
import { colors, typography } from '@dixa/lib-shared-tokens';
import classnames from 'classnames';
import { Cell, Pie, PieChart } from 'recharts';
import styles from './conversations.module.scss';
const LEGEND_CONFIG = [
    {
        type: 'total_conversations',
        name: 'Total',
        color: colors.neutral[400],
        shape: 'square',
    },
    {
        type: 'answered_conversations',
        name: 'Answered',
        color: colors.green[400],
        shape: 'circle',
    },
    {
        type: 'transfered_conversations',
        name: 'Timeouts',
        color: colors.blue[400],
        shape: 'circle',
    },
    {
        type: 'abandoned_conversations',
        name: 'Abandoned',
        color: colors.red[400],
        shape: 'circle',
    },
];
const CHART_CONFIG = [
    {
        type: 'answered_conversations',
        color: colors.green[400],
    },
    {
        type: 'conversations_in_queue',
        color: colors.orange[400],
    },
    {
        type: 'transfered_conversations',
        color: colors.blue[400],
    },
    {
        type: 'abandoned_conversations',
        color: colors.red[400],
    },
];
const DIAMETER = 72;
const STROKE = 8;
export const Conversations = ({ dashboardQueue, }) => {
    var _a;
    const total = (_a = dashboardQueue.conversations_in_queue) !== null && _a !== void 0 ? _a : 0;
    const data = CHART_CONFIG.map(({ type, color }) => {
        var _a;
        return ({
            value: (_a = dashboardQueue[type]) !== null && _a !== void 0 ? _a : 0,
            color,
        });
    }).filter((item) => !!item.value);
    return (_jsxs(FlexBox, Object.assign({ alignItems: "center", gap: "400" }, { children: [_jsxs(PieChart, Object.assign({ width: DIAMETER, height: DIAMETER }, { children: [_jsx(Pie, Object.assign({ data: data.length ? data : [{ value: 1 }], dataKey: "value", innerRadius: DIAMETER / 2 - STROKE, outerRadius: DIAMETER / 2, startAngle: 90, endAngle: -270, fill: colors.neutral[300], stroke: "none", isAnimationActive: false }, { children: data.map((cell, index) => (_jsx(Cell, { fill: cell.color, strokeWidth: 0 }, `cell-${index}`))) })), _jsx("text", Object.assign({ x: "50%", y: "50%", dy: parseInt(typography.size[400], 10) / 2 - 1, fill: total > 0 ? colors.orange[400] : colors.neutral[300], fontSize: typography.size[400], fontWeight: typography.weight.semibold, textAnchor: "middle" }, { children: total }))] })), _jsx("ul", Object.assign({ className: styles.legend }, { children: LEGEND_CONFIG.map(({ name, color, type, shape }) => (_jsxs("li", Object.assign({ className: styles.legendItem }, { children: [_jsx("div", { className: classnames({ [styles[shape]]: true }, styles.legendIcon), style: { backgroundColor: color } }), _jsx(Text.Paragraph, Object.assign({ variant: "4", className: styles.legendLabel }, { children: name })), _jsx(Text.Paragraph, Object.assign({ variant: "1", className: styles.legendCount }, { children: dashboardQueue[type] || 0 }))] }), type))) }))] })));
};
